<template>
  <span v-bind:class="spinnerType">
    <clip-loader :color="color"></clip-loader>
  </span>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  props: {
    /** the "spinner-type" prop is optional and it accepts -
     * 1. v-spinner--icon
     * 2. v-spinner-btn--icon
     **/

    spinnerType: {
      type: String,
      default: 'v-spinner--icon'
    },
    color: {
      type: String,
      default: '#198F9E'
    }
  },
  components: {
    'clip-loader': ClipLoader
  }
}
</script>

<style lang="scss" scoped>
@import './spinner.component.scss';
</style>
